import { contracts } from '../../data/contracts'

export default {
	name: 'ARPA',
	shortName: 'ARPA',
	contractAddress: contracts[process.env.REACT_APP_NETWORK].arpaAddress,
	url: 'http://lorem.com',
	logo: 'tokens/Arpa.png'
}
